import { Spoiler as MantineSpoiler, Text } from "@mantine/core";
import type { CSSProperties } from "react";

import { useStyles } from "./Spoilers.styles.ts";

interface SpoilerProps {
  text: string;
  maxStringLength?: number;
  width?: string | number;
  style?: CSSProperties;
}

const Spoiler = ({
  text,
  maxStringLength = 17,
  width,
  style,
}: SpoilerProps) => {
  const { classes } = useStyles();

  return (
    <>
      {text.length > maxStringLength ? (
        <MantineSpoiler
          maxHeight={21}
          w={width}
          hideLabel="Hide"
          showLabel="More"
          style={style}
          className={classes.wrapper}
        >
          <Text
            className={classes.textWrapper}
            dangerouslySetInnerHTML={{ __html: text }}
          />
        </MantineSpoiler>
      ) : (
        <Text style={style}>{text}</Text>
      )}
    </>
  );
};

export default Spoiler;
